import visitService from "@/services/visit";
// import router from "../../router/index";

const getDefaultState = () => {
    return {
        dataSource: [],
        sitesData : [],
        usersData : [], 
        hostsData : [], 
        userTypesData : [],
        expextedVisitValidation : [],
        expextedVisit : [],
        journeyHasHost : [],
        isQuickSignInSubmitClicked: false,
        // loading: false,
    };
};

export const state = getDefaultState();

export const actions = {
    fetchVisitsSummary({ commit }, { start_date, end_date }) {
        return new Promise((resolve, reject) => {
            visitService
                .fetchVisitsSummary(start_date, end_date)
                .then((data) => {
                resolve(data);
                    commit("setVisitsSummary", data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },    
    clearVisitSummaryGrid({commit}){
        commit('clearGrid')
    },
    fetchSitesAndAreasByEntityId() {
        return new Promise((resolve , reject ) => {
            visitService
            .getAllSitesWithAreasByEntityId()
            .then((data) => {
            //   commit("setSitesAndAreasByEntityId", data.data);
              resolve(data);
            })
            .catch((err) => {
              reject(err);
              err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
            });
        });
    },
    fetchAreaDataById({ commit }, id) {
        commit("setLoadingStatus",false);

        return new Promise((resolve , reject ) => {
            visitService
            .getAreaDataById(id)
            .then((data) => {
            //   commit("setSitesAndAreasByEntityId", data.data);
              resolve(data);
            })
            .catch((err) => {
              reject(err);
              err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
            });
        });
    },
    usersBySearch({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve , reject ) => {
            visitService
            .searchForUser(payload)
            .then((data) => {
            //   commit("setUsersBySearch", data.data);
              resolve(data);
            })
            .catch((err) => {
              reject(err);
              err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
            });
        });
    },
    hostsBySearch({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve , reject ) => {
            visitService
            .searchForHost(payload)
            .then((data) => {
            //   commit("setHostsBySearch", data.data);
              resolve(data);
            })
            .catch((err) => {
              reject(err);
              err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
            });
        });
    },
    fetchUsersByEmailOrPhone({ commit }, payload) {
        return new Promise((resolve , reject ) => {
            visitService
            .getUsersByEmailOrPhone(payload)
            .then((data) => {
                commit("setUsersByEmailOrPhone", data.data);
                resolve(data);
            })
            .catch((err) => {
              reject(err);
              err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
            });
        });
    },
    fetchUserTypesWithAreaId({ commit }, id) {
        commit("setLoadingStatus",false);
        return new Promise((resolve , reject ) => {
            visitService
            .userTypesWithAreaId(id)
            .then((data) => {
            //   commit("setUserTypesByAreaId", data.data);
              resolve(data);
            })
            .catch((err) => {
              reject(err);
              err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
            });
        });
    },
    chechIfUserHasExpextedVisit({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            visitService
            .chechIfUserHasExpextedVisit(payload)
            .then((data) => {
                resolve(data);
            })
            .catch((err) => {
                commit("setExpectedVisitValidation", err.data);
                reject(err);
            //   this._vm.$toast.error(err.data.data.message ? err.data.data.message : err.data.message);
            });
        });
    },
    addExpextedVisit({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            visitService
            .addExpextedVisit(payload)
            .then((data) => {
            //   router.push("/");
              resolve(data);
              this._vm.$toast.success("Visit has been added successfully.");
            })
            .catch((err) => {
                commit("setExpectedVisit", err.data);
                reject(err);
                // this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
            });
        });
    },
    checkIfJourneyHasHost({ commit }, payload) {
        commit("setLoadingStatus",false);
        return new Promise((resolve, reject) => {
            visitService
            .checkIfJourneyHasHost(payload)
            .then((data) => {
                // commit("setJourneyHasHost", data.data);
                resolve(data);
            })
            .catch((err) => {
                reject(err);
                this._vm.$toast.error(err.data.message ? err.data.message : err.data.message);
            });
        });
    },
    submitQuickSignIn({commit},payload){
        commit("setIsQuickSignInSubmitClicked",payload)
    }
};

export const mutations = {
    setVisitsSummary(state, payload) {
        state.dataSource = payload;
    },
    clearGrid(state) {
        state.dataSource = []
    },
    setSitesAndAreasByEntityId(state, payload) {
        state.sitesData = payload;
    },
    setUsersBySearch(state, payload) {
        state.usersData = payload;
    },
    setHostsBySearch(state, payload) {
        state.hostsData = payload;
    },
    setUsersByEmailOrPhone(state, payload) {
        state.usersByEmailOrPhoneData = payload;
    },
    setUserTypesByAreaId(state, payload) {
        state.userTypesData = payload;
    },
    setLoadingStatus(state, loading) {
        state.loadingStatus = loading;
    },
    setExpectedVisitValidation(state, payload) {
        state.expextedVisitValidation = payload;
    },
    setExpectedVisit(state, payload) {
        state.expextedVisit = payload;
    },
    setJourneyHasHost(state, payload) {
        state.journeyHasHost = payload;
    },
    setIsQuickSignInSubmitClicked(state,payload){
        state.isQuickSignInSubmitClicked = payload
    }
}

export const getters = {
    getVisitsSummary(state) {
        return state.dataSource;
    },
    getSitesAndAreasByEntityId(state) {
        return state.sitesData;
    },
    getUsersBySearch(state) {
        return state.usersData;
    },
    getHostsBySearch(state) {
        return state.hostsData;
    },
    getUsersByEmailOrPhone(state) {
        return state.usersByEmailOrPhoneData;
    },
    getUserTypesByAreaId(state) {
        return state.userTypesData;
    },
    getExpectedVisitValidation(state) {
        return state.expextedVisitValidation;
    },
    getExpectedVisit(state) {
        return state.expextedVisit;
    },
    getIfJourneyHasHost(state) {
        return state.journeyHasHost;
    },
    getIsQuickSignInSubmitClicked(state){
        return state.isQuickSignInSubmitClicked
    }
};